import { isApiError } from '@/helpers/apiClient'
import { toErrorMessage } from '@/helpers/logger'

/** A user-facing message for a failed request: the API's own message when it sent one. */
export function apiErrorMessage<E>(error: E, fallback = 'Something went wrong. Please try again.'): string {
  if (isApiError(error)) {
    return error.body.message ?? fallback
  }
  return toErrorMessage(error) || fallback
}

/**
 * The API's per-field messages for a failed request, keyed by the first
 * segment of each `errors[].path` (`embedOrigins[1]` → `embedOrigins`), kept
 * only for the form's own fields. `null` when none of them apply, so the
 * caller falls back to a form-level message.
 */
export function apiFieldErrors<E, K extends string>(error: E, fields: readonly K[]): Partial<Record<K, string>> | null {
  if (!isApiError(error)) return null
  const found: Partial<Record<K, string>> = {}
  let any = false
  for (const detail of error.body.errors ?? []) {
    const head = detail.path.split(/[.[]/)[0]
    const field = fields.find((key) => key === head)
    if (field === undefined || found[field] !== undefined) continue
    found[field] = detail.message
    any = true
  }
  return any ? found : null
}
